var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmbarrassment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 14C27 14.2652 26.8946 14.5196 26.7071 14.7071C26.5196 14.8946 26.2652 15 26 15C25.7348 15 25.4804 14.8946 25.2929 14.7071C25.1054 14.5196 25 14.2652 25 14C24.9964 10.8185 23.7309 7.76839 21.4813 5.51874C19.2316 3.26909 16.1815 2.00364 13 2C12.825 2 12.65 2 12.4775 2.0125C9.91972 2.14815 7.51132 3.25937 5.74821 5.11736C3.98511 6.97534 3.00152 9.43863 3 12C3.00232 14.121 3.84591 16.1545 5.3457 17.6543C6.84549 19.1541 8.87898 19.9977 11 20C12.4582 19.9983 13.8562 19.4184 14.8873 18.3873C15.9184 17.3562 16.4983 15.9582 16.5 14.5C16.5 13.4391 16.0786 12.4217 15.3284 11.6716C14.5783 10.9214 13.5609 10.5 12.5 10.5C12.2348 10.5 11.9804 10.6054 11.7929 10.7929C11.6054 10.9804 11.5 11.2348 11.5 11.5C11.5 11.7652 11.6054 12.0196 11.7929 12.2071C11.9804 12.3946 12.2348 12.5 12.5 12.5C13.0304 12.5 13.5391 12.7107 13.9142 13.0858C14.2893 13.4609 14.5 13.9696 14.5 14.5C14.5 15.4283 14.1313 16.3185 13.4749 16.9749C12.8185 17.6313 11.9283 18 11 18C9.40921 17.9983 7.88405 17.3657 6.75919 16.2408C5.63433 15.116 5.00165 13.5908 5 12C5.00232 9.87898 5.84591 7.84549 7.3457 6.3457C8.84549 4.84591 10.879 4.00232 13 4C15.6513 4.00298 18.1931 5.0575 20.0678 6.93222C21.9425 8.80694 22.997 11.3487 23 14C22.9967 16.9164 21.8367 19.7123 19.7745 21.7745C17.7123 23.8367 14.9164 24.9967 12 25C8.81852 24.9964 5.76839 23.7309 3.51874 21.4813C1.26909 19.2316 0.0036392 16.1815 0 13C0.00363977 9.5533 1.37445 6.24882 3.81163 3.81163C6.24882 1.37445 9.5533 0.00363977 13 0C16.7118 0.00397056 20.2705 1.48024 22.8951 4.10489C25.5198 6.72954 26.996 10.2882 27 14Z",
    fill: "url(#paint0_linear_668_28136)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_28136",
    x1: -8.04663e-7,
    y1: 25,
    x2: 31.1992,
    y2: 7.47638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BBBB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbarrassment);
export default __webpack_public_path__ + "static/media/Embarrassment.220a6a0f40da01cd48b270256b9cbf8c.svg";
export { ForwardRef as ReactComponent };